import { useState, useEffect } from 'react'
import { useHistory, useParams, Link } from 'react-router-dom'
import {VehicleGet, VehicleUpdate} from "services/vehicleService";

import { useDispatch, useSelector } from 'react-redux'
import { AppDispatch, RootState } from 'store'
import { fetchLicenseClasses } from 'store/licenseSlice'
import {toast} from "react-hot-toast";
import { FILTER_KEYWORDS } from 'constants/filterKeywords'
import {fetchPartners} from "store/partnerSlice";
import { ArrowLeft, Save } from 'lucide-react';

export default function EditVehiclePage() {
    const {id}: any = useParams()
    const router = useHistory()
    const dispatch = useDispatch<AppDispatch>()

    const licenseClasses = useSelector((state: RootState) => state.licenseClasses.items)
    const partners = useSelector((state: RootState) => state.partners.items)

    const [licensePlate, setLicensePlate] = useState('')

    const filteredLicenseClasses = licenseClasses.filter(license => {
        return !FILTER_KEYWORDS.some(keyword =>
            license.name.toLowerCase().includes(keyword.toLowerCase())
        );
    });

    const [error, setError] = useState('')
    const [isLoading, setIsLoading] = useState(false)
    const [licenseClassId, setLicenseClassId] = useState('')
    const [partnerId, setPartnerId] = useState('')
    const [type, setType] = useState('')
    const [note, setNote] = useState('')


    useEffect(() => {
        const fetchVehicle = async () => {
            try {
                if (licenseClasses.length === 0) {
                    await dispatch(fetchLicenseClasses())
                }
                if (partners.length === 0) {
                    dispatch(fetchPartners())
                }
                const response = await VehicleGet(id as string)
                if (!response.result) {
                    throw new Error('Failed to fetch vehicle')
                }
                const data  = response.result
                setLicensePlate(data.plateNumber)
                setLicenseClassId(data.licenseClassId || '')
                setPartnerId(data.partnerId || '')
                setType(data.type || '')
                setNote(data.note || '')
            } catch (err) {
                setError('Không thể tải thông tin xe')
            }
        }



        fetchVehicle()
    }, [id])

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault()

        if (!licensePlate || !licenseClassId) {
            setError('Vui lòng điền đầy đủ thông tin')
            return
        }

        setIsLoading(true)
        setError('')

        try {
            const response = await VehicleUpdate(
                {
                    // @ts-ignore
                    id: id ,
                    plateNumber: licensePlate,
                    licenseClassId: licenseClassId,
                    partnerId: partnerId || null,
                    type: type || null,
                    note: note || null
                }
            )
            toast.success('Cập nhật xe thành công')

            router.push('/vehicles')
        } catch (err: any) {
            setError(err.message || 'Đã xảy ra lỗi khi cập nhật xe')
        } finally {
            setIsLoading(false)
        }
    }

    return (
        <div className="container mx-auto px-4 py-8">
            <div className="flex justify-between items-center mb-6">
                <Link
                    to="/vehicles"
                    className="flex items-center text-blue-600 hover:text-blue-800"
                >
                    <ArrowLeft className="mr-2" />
                    Quay lại
                </Link>
                <h1 className="text-3xl font-bold text-gray-800">Chỉnh sửa thông tin xe</h1>
                <div></div> {/* For alignment */}
            </div>

            <div className="bg-white rounded-lg shadow-md p-6 max-w-2xl mx-auto">
                {error && (
                    <div className="mb-4 p-3 bg-red-50 text-red-700 rounded-md">
                        {error}
                    </div>
                )}

                <form onSubmit={handleSubmit}>
                    <div className="mb-4">
                        <label htmlFor="licensePlate" className="block text-sm font-medium text-gray-700 mb-1">
                            Biển số xe *
                        </label>
                        <input
                            type="text"
                            id="licensePlate"
                            value={licensePlate}
                            onChange={(e) => setLicensePlate(e.target.value)}
                            className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                            required
                        />
                    </div>

                    <div className="mb-6">
                        <label htmlFor="rank" className="block text-sm font-medium text-gray-700 mb-1">
                            Hạng đào tạo *
                        </label>
                        <select
                            id="licenseClass"
                            value={licenseClassId}
                            onChange={(e) => setLicenseClassId(e.target.value)}
                            className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                            required
                        >
                            <option value="">Chọn hạng đào tạo</option>
                            {filteredLicenseClasses.map((lc) => (
                                <option key={lc.id} value={lc.id}>
                                    {lc.name}
                                </option>
                            ))}
                        </select>
                    </div>
                    <div className="mb-6">
                        <label htmlFor="partner" className="block text-sm font-medium text-gray-700 mb-1">
                            Đơn vị liên kết
                        </label>
                        <select
                            id="partner"
                            value={partnerId}
                            onChange={(e) => setPartnerId(e.target.value)}
                            className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                        >
                            <option value="">Không</option>
                            {partners.map((partner) => (
                                <option key={partner.id} value={partner.id}>
                                    {partner.name}
                                </option>
                            ))}
                        </select>
                    </div>

                    <div className="mb-4">
                        <label htmlFor="type" className="block text-sm font-medium text-gray-700 mb-1">
                            Loại xe
                        </label>
                        <input
                            type="text"
                            id="type"
                            value={type}
                            onChange={(e) => setType(e.target.value)}
                            className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                        />
                    </div>

                    <div className="mb-6">
                        <label htmlFor="note" className="block text-sm font-medium text-gray-700 mb-1">
                            Ghi chú
                        </label>
                        <textarea
                            id="note"
                            value={note}
                            onChange={(e) => setNote(e.target.value)}
                            className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                            rows={3}
                        ></textarea>
                    </div>


                    <div className="flex justify-end">
                        <button
                            type="submit"
                            disabled={isLoading}
                            className="flex items-center px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 disabled:opacity-50"
                        >
                            {isLoading ? (
                                <>
                                    <svg className="animate-spin -ml-1 mr-2 h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                        <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                    </svg>
                                    Đang lưu...
                                </>
                            ) : (
                                <>
                                    <Save className="mr-2" />
                                    Lưu thông tin
                                </>
                            )}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    )
}